import { Location } from "@angular/common";
import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent {
  /**
   * Constructor
   */
  constructor(private _router: Router, private location: Location) {}

  openChangeLog() {
    this._router.navigate(["/other/changelog"]);
  }

  back() {
    this.location.back();
  }
}
